<template>
<!-- Make the text component dynamic, since this is used more than once -->
  <b-container id="page-loader-container" fluid class="px-7 py-5">
    <b-row class="height-fluid">
      <b-col cols="4" class="d-flex flex-column justify-content-between">
        <img src="@/assets/images/logo_lime.svg" width="100">
        <span class="link">
          WWW.WINONA.COM
        </span>
      </b-col>
      <b-col cols="8" class="px-5 d-flex flex-column justify-content-center">
        <div id="loader-text" v-if="loaderType == 0">
          <p>
          Hey! We are excited to get to know you, and help on your menopause journey!
          </p>
          <p>
          Please start your brief, and painless, online visit to confirm your interests, concerns, &amp; skincare goals.
          With this information, our medical team can send your personalized treatments directly to your home.
          </p>
          <p>
          All personal information is properly store, and protected by our HIPAA compliant medical system.
          </p>
          <span>
            <b-button
              size="lg"
              variant="link"
              id="continue-button"
              class="mt-3 px-0"
              @click="redirect"
            >
            Continue <img src="@/assets/images/arrow_lime.svg" class="ml-2 mb-1" width="50px"/>
            </b-button>
          </span>
        </div>
        <div id="loader-text" v-if="loaderType == 1">
          <p>
            Your first Winona doctor visit is free. Once Winona Physician creates your customized prescription treatment plan, you will be able to confirm your personalized hormonal treatment products.
          </p>
          <p>
            Winona will credit the $20 doctor visit costs directly to the cost of any Rx medications fulfilled through the Winona pharmacy.
          </p>
          <span>
            <b-button
              size="lg"
              variant="link"
              id="continue-button"
              class="mt-3 px-0"
            >
            Continue <img src="@/assets/images/arrow_lime.svg" class="ml-2 mb-1" width="50px"/>
            </b-button>
          </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      loaderType: 0
    }
  },
  methods: {
      redirect () {
        this.$router.push('/health-questions').catch(()=>{});
      }
    }
}
</script>

<style lang="scss" scoped>
#page-loader-container {
  background-color: #1A6A72;
  height: 100vh;
}
#continue-button {
  color: #CDFCB1;
  font-size: 18px;
}
.link {
  font-size: 16px;
  writing-mode: vertical-rl;
  transform: scale(-1, -1);
  letter-spacing: 0.18em;
  color: #CDFCB1;
}
#loader-text {
  width: 670px;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  color: #CDFCB1;
  letter-spacing: 0.02em;
}
.height-fluid {
  min-height: 90vh
}
</style>